import React from 'react'

export default function Footer() {
	return (
		<div className='footer'>
			<div className='footer-nav'>
				<a href='https://leasequery.com/'>Homepage</a>
			</div>
			<div className='footer-nav'>
				<a href='https://leasequery.com/about-us/'>About Us</a>
			</div>
			<div className='footer-nav'>
				<a href='https://leasequery.com/terms-and-conditions/'>
					Terms and Conditions
				</a>
			</div>
			<div></div>
			<div className='footer-nav-copyright'>
				© Copyright 2021 - LeaseQuery.com
			</div>
		</div>
	)
}
